/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiServicesDataTransferObjectsGroupServiceSendMailToGroupDto
 */
export interface WebApiServicesDataTransferObjectsGroupServiceSendMailToGroupDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceSendMailToGroupDto
     */
    groupId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceSendMailToGroupDto
     */
    subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceSendMailToGroupDto
     */
    message?: string | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsGroupServiceSendMailToGroupDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsGroupServiceSendMailToGroupDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsGroupServiceSendMailToGroupDtoFromJSON(json: any): WebApiServicesDataTransferObjectsGroupServiceSendMailToGroupDto {
    return WebApiServicesDataTransferObjectsGroupServiceSendMailToGroupDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsGroupServiceSendMailToGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsGroupServiceSendMailToGroupDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function WebApiServicesDataTransferObjectsGroupServiceSendMailToGroupDtoToJSON(value?: WebApiServicesDataTransferObjectsGroupServiceSendMailToGroupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'groupId': value.groupId,
        'subject': value.subject,
        'message': value.message,
    };
}

